export enum LNUMode {
  NotDefined = 0,
  ManualAllowancePerCustomer = 1,
  PercentageOfBilling = 2,
  SmartMeter = 3,
  PercentageOfMNF = 4,
}
